export default class HouseholdIncomeRanges {
  static options(hhiDemographics) {
    const uniqueValues = this.uniqueHouseholdRangesValue(hhiDemographics);
    //
    // Temporary fix to match ranges to percentages
    //
    const uniqueValuesLength = uniqueValues.length;
    const hivestackCanadaHHIIncrementsLength = this.hivestackCanadaHHIIncrements.length;
    const kineticHHIIncrementsLength = this.kineticHHIIncrements.length;
    switch (uniqueValuesLength) {
      case kineticHHIIncrementsLength:
        return uniqueValues.map((_x, i) => this.kineticHHIIncrements[i]);
      case hivestackCanadaHHIIncrementsLength:
        return uniqueValues.map((_x, i) => this.hivestackCanadaHHIIncrements[i]);
      default:
        return uniqueValues.length > 1 ? uniqueValues : [];
    }
  }

  static optionsFormatted(hhiDemographics) {
    const uniqueValues = this.uniqueHouseholdRangesValue(hhiDemographics);
    return uniqueValues.length > 1 ? uniqueValues : [];
  }

  static uniqueHouseholdRangesValue(hhiDemographics) {
    //
    // Usually BE sends data in asc order, now it's mixed ex: [80000 - 300000, 300000+, 0 - 80000]
    // So it needs sorting in asc order
    //
    const hhiValues = hhiDemographics
      .map((x) => (x.code.includes(' ') ? x.code.split(' ')[1] : x.code))
      .filter((x) => x.includes('-') || x.includes('+'))
      .reduce((res, x, i, arr) => {
        if (x.includes('-')) {
          // We always add both the start and end if its the last one, otherwise just the start
          const addition = arr.length - 1 === i ? x.split('-') : [x.split('-')[0]];
          return [...res, ...addition];
        } else {
          return [...res, x];
        }
      }, []);
    const highestHHIValue = hhiValues.filter((x) => x.includes('+'));
    const sortedHHIValues = hhiValues.filter((x) => !x.includes('+')).sort((a, b) => a - b);
    const uniqueValues = Array.from(new Set([...sortedHHIValues, ...highestHHIValue]));
    if (uniqueValues.length > 1 && uniqueValues.some((x) => x.includes('+'))) {
      const index = uniqueValues.findIndex((x) => x.includes('+'));
      uniqueValues[index] = uniqueValues[index].replace('+', '');
      uniqueValues.push(`${uniqueValues[index]}+`);
    }
    return uniqueValues;
  }

  static kineticHHIIncrements = ['0', 'Lower 50%', 'Top 41-50%', 'Top 31-40%', 'Top 21-30%', 'Top 11-20%', 'Top 10%'];

  static hivestackCanadaHHIIncrements = [
    '0',
    'Lower 50%',
    'Top 40-49%',
    'Top 30-39%',
    'Top 20-29%',
    'Top 10-19%',
    'Top 5-9%',
    'Top 1%',
  ];

  static getSortedHHIDemos(hhiDemos) {
    const allUniqueHHI = this.uniqueHouseholdRangesValue(hhiDemos);
    const maxHouseHoldIncomeDemo = hhiDemos.filter((x) => x.code.includes('+'));
    const sortedHHIDemos = [];
    allUniqueHHI.map((income) => {
      const hhiDemo = hhiDemos.find((demo) => demo.code.split('-')[0]?.split(' ')[1] === income);
      if (hhiDemo != null) {
        sortedHHIDemos.push(hhiDemo);
      }
      return income;
    });
    if (sortedHHIDemos.length + 1 === allUniqueHHI.length) {
      sortedHHIDemos.push(...maxHouseHoldIncomeDemo);
    }

    return sortedHHIDemos;
  }
}
